import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({ providedIn: 'root' })
export class IconService {
  private operationIcons = [
    'web_asset', 'delete_outline','keyboard_arrow_up','keyboard_arrow_down',
    'brightness_auto','quiz','live_help','pending_actions','work_history','backup_table',
    'send',
    'create_new_folder',
    'playlist_add_check',
    'pageview',
    'assignment_ind',
    'laptop_chromebook',
    'playlist_play',
    'flag',
    'receipt',
    'category',
    'print',
    'subject',
    'image_aspect_ratio',
    'calendar_today',
    'assignment',
    'all_out',
    'contacts',
    'assessment',
    'group_add',
    'cloud_upload',
    'file_copy',
    'import_export',
    'pause',
    'question_answer',
    'speaker_notes',
    'web_asset',
    'description',
    'restore_page',
    'add_alarm',
    'pause_circle',
    'toggle_off',
    'published_with_changes',
    'build_circle',
    'image_aspect_ratio',
    'featured_play_list',
    'group', 'logout', 'filter_alt', 'cloud_download', 'delete', 'playlist_add', 'edit', 'view_headline', 'arrow_back',
    'library_add', 'check', 'check_circle', 'close', 'close_circle', 'done', 'done_all', 'error', 'error_outline', 'info', 'info_outline', 'warning', 'warning_amber', 'menu', 'settings', 'arrow_drop_down'
  ];


  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.preloadOperationIcons();
  }

  preloadOperationIcons(): () => void {
    const uniqueIcons = Array.from(new Set(this.operationIcons));
    for (const icon of uniqueIcons) {
      let url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `assets/img/icons/material-design-icons/two-tone/${icon}.svg`
      )
      this.matIconRegistry.addSvgIconInNamespace(
        'mat',
        icon,
        url
      );
      // // Create a temporary mat-icon element to force preload
      // const tempIcon = document.createElement('mat-icon');
      // tempIcon.setAttribute('svgIcon', `mat:${icon}`);
      // tempIcon.style.display = 'none';
      // document.body.appendChild(tempIcon);

      // // Remove the icon after it loads
      // setTimeout(() => {
      //   document.body.removeChild(tempIcon);
      // }, 100);


    }

    return () => { };
  }
}
